// extracted by mini-css-extract-plugin
export var infoRow = "_uk-2";
export var labelContainer = "_uk-0";
export var rightInfo = "_uk-1";